'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(body) {
    return {
        currentBid: body.current_bid,
        isCurrentHighBid: body.is_current_high_bid,
        isReserveMet: body.is_reserve_met,
        leadingBid: body.leading_bid,
        success: body.success
    };
};

var BidRemote = exports.BidRemote = {
    postPlaceAbsenteeBid: function postPlaceAbsenteeBid(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            details = _ref.details;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<MAINHOST-API>api/abs_bid' });
            request.type('form');
            request.send({
                accept_terms: true,
                bid: details.bidAmount,
                cat_id: details.catalogId,
                lot_id: details.itemId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    },
    postRetractBid: function postRetractBid(_ref2) {
        var authToken = _ref2.authToken,
            bidderId = _ref2.bidderId,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId,
            retractionExplanation = _ref2.retractionExplanation,
            retractionReason = _ref2.retractionReason;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/bidders/' + bidderId + '/biditems/' + itemId + '/retract'
            });
            request.send({
                retractionExplanation: retractionExplanation,
                retractionReason: retractionReason
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/bid.js
// module id = 2+GA
// module chunks = 60